<template>
    <div class="text-center">
        <div class="pagination">
            <a href="#" @click.prevent="changeData(PageNum -1)">&laquo;</a>
            <a href="#" v-if="fristPage" @click.prevent="changeData(1)">1</a>
            <span style="display:inline;" v-if="fristPage">...</span>
            <a href="#" v-for="d in totalPageCount" :key="d" :name="d" :style="{'display': hiddenPage(d) ? 'none' : ''}" :class="{'active' : PageNum === d}"  @click.prevent="changeData(d)">{{ d }}</a>
            <span style="display:inline;" v-if="endPage">...</span>
            <a href="#" v-if="endPage" @click.prevent="changeData(totalPageCount)">{{totalPageCount}}</a>
            <a href="#" @click.prevent="changeData(PageNum+1)">&raquo;</a>
        </div>
    </div>
</template>
<style scoped>
  .pagination {
    display: inline-block;
  }
  .pagination span{
    display: inline-block;
  }
  .pagination a {
    display: inline-block;
    border-radius: 50px;
    color: #444;
    font-size: .9em;
    padding: .5em 1em;
    text-decoration: none;
  }
  .pagination a.active {
    background-color: #0187d7;
    color: #ffffff;
  }
  .pagination a:hover:not(.active) {
      background-color: #ddd;
      border-radius: 50%;
      opacity: 0.5;
    }
</style>

<script>
export default {
    props: ['item'],
    data(){                
        return {            
            totalPageCount: this.item.totalPageCount,
            pageCount: this.item.pageCount,
            PageNum: 1,
            fristPage: false,
            endPage: this.item.totalPageCount > this.item.pageCount * 2 + 1
        }     
    },
    methods:{
        changeData(page){                   
            if(page < 1){
                page = 1
            }
            else if(page > this.totalPageCount){
                page = this.totalPageCount;
            }
            this.PageNum = parseInt(page);            
            this.$emit('pageNumForComponent', this.PageNum)
        },
        hiddenPage(page){            
            var _beg = this.PageNum - this.pageCount
            var _end = this.PageNum + this.pageCount + (_beg < 1 ? 1 : 0)
            var result = false
            if(this.PageNum === 1){                        
                if(page <= (this.PageNum + this.pageCount * 2)){
                //return false
                }
                else{                                     
                result = true
                }
            }else if(this.PageNum === this.totalPageCount){                
                if(page >= (this.PageNum - this.pageCount * 2)){
                //return false
                }
                else{                      
                result = true
                }
            }else{
                if(page === this.PageNum){
                //return false
                }
                else if(page >= _beg && page <= _end){
                //return false
                }
                else{                    
                result = true
                }
            }   
            // if(page === 1 && result){ this.fristPage = true } else { this.fristPage = false }
            // if(page === this.totalPageCount && result){ this.endPage = true } else { this.endPage = false }            
            return result;                 
        },
        renderPage(){
            if( this.item.totalPageCount < this.PageNum || this.item.PageNum == 1){
                this.PageNum = 1
            }
            this.totalPageCount = this.item.totalPageCount;
        }
    },
    updated(){        
        if(document.getElementsByName("1")[0].style.display === 'none'){
            this.fristPage = true;
        }else{
            this.fristPage = false;
        }
        if(document.getElementsByName(this.totalPageCount)[0].style.display === 'none'){
            this.endPage = true;
        }else{
            this.endPage = false;
        }

    },
    watch:{
        $props:{
            handler() {
                // console.log(this.item);
                this.renderPage();
            },
            deep: true  
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/PageList.vue